import React, { useState } from 'react';
import './Ticket.css';
import { Check, ChevronDown } from 'lucide-react';
import { Listbox } from '@headlessui/react';
import { Toaster, toast } from 'sonner';
// import { set } from '../../../../functions/ocrfunction';
import { ChevronLeft, ChevronRight } from "lucide-react";
import { useNavigate } from "react-router-dom";
const employeeData = [
 
  {
    name: 'Samantha Ray',
    employeeId: 'EMP001',
    jobTitle: 'Front Desk Executive',
    department: 'Guest Services',
    joiningDate: '2020-01-15',
    workingdays: "360",
    leave: "10",
    incentive: "5000",
    performance: "4",
    salesbillcount: "50",
    salesbillamount: "200000",
    salary: " $ 14",
    experience: "2 years",
  },
  {
    name: 'Alex Johnson',
    employeeId: 'EMP002',
    jobTitle: 'Hotel Manager',
    department: 'Management',
    joiningDate: '2019-05-20',
    workingdays: "360",
    leave: "10",
    incentive: "5000",
    performance: "4",
    salesbillcount: "50",
    salesbillamount: "200000",
    salary: " $ 14",
    experience: "2 years",
  },
  {
    name: 'Priya Sharma',
    employeeId: 'EMP003',
    jobTitle: 'Housekeeping Supervisor',
    department: 'Housekeeping',
    joiningDate: '2021-08-10',
    workingdays: "360",
    leave: "10",
    incentive: "5000",
    performance: "4",
    salesbillcount: "50",
    salesbillamount: "200000",
    salary: " $ 14",
    experience: "2 years",
  },
  {
    name: 'David Kim',
    employeeId: 'EMP004',
    jobTitle: 'Sous Chef',
    department: 'Kitchen',
    joiningDate: '2018-03-12',
    workingdays: "360",
    leave: "10",
    incentive: "5000",
    performance: "4",
    salesbillcount: "50",
    salesbillamount: "200000",
    salary: " $ 14",
    experience: "2 years",
  },
  {
    name: 'Emma Williams',
    employeeId: 'EMP005',
    jobTitle: 'Event Coordinator',
    department: 'Banquets',
    joiningDate: '2022-06-05',
    workingdays: "360",
    leave: "10",
    incentive: "5000",
    performance: "4",
    salesbillcount: "50",
    salesbillamount: "200000",
    salary: " $ 15",
    experience: "3 years",
  },
  {
    name: 'Mohammed Ali',
    employeeId: 'EMP006',
    jobTitle: 'Concierge',
    department: 'Guest Services',
    joiningDate: '2017-09-25',
    workingdays: "360",
    leave: "10",
    incentive: "5000",
    performance: "4",
    salesbillcount: "50",
    salesbillamount: "200000",
    salary: " $ 10",
    experience: "2 years",
  },
  {
    name: 'Liu Wei',
    employeeId: 'EMP007',
    jobTitle: 'Bellhop',
    department: 'Lobby Services',
    joiningDate: '2020-11-30',
    workingdays: "360",
    leave: "10",
    incentive: "5000",
    performance: "4",
    salesbillcount: "50",
    salesbillamount: "200000",
    salary: " $ 14",
    experience: "1 years",
  },
];


const performanceFields = [
  { name: 'leadership', label: 'Leadership' },
  { name: 'collaboration', label: 'Team Collaboration' },
  { name: 'goals', label: 'Goal Achievement' },
  { name: 'communication', label: 'Communication Skills' },
];

export const Promotionform = () => {
  const [selectedemployeeType, setSelectedemployeeType] = useState({ name: 'select employee' });
 const [loading, setLoading] = useState(false);
 const [search, setSearch] = useState("");
 const [page, setPage] = useState(1);
 const [sortField, setSortField] = useState("");
 const [sortOrder, setSortOrder] = useState("asc");

  const [formData, setFormData] = useState({
    employee: '',
    employeeId: '',
    newTitle: '',
    effectiveDate: '',
    newDepartment: '',
    newManager: '',
    justification: '',
    achievements: '',
    proposedBy: '',
    proposedDate: '',
    approvedBy: '',
    approvedDate: '',
    performance: {
      leadership: 1,
      collaboration: 1,
      goals: 1,
      communication: 1,
    },
  });
  const [ratings, setRatings] = useState({
    leadership: 1,
    collaboration: null,
    goals: null,
    communication: null,
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
 

const payload = {

  ticket_type: "Promotion",
  employee_name: selectedemployeeType.name,
  employee_id: selectedemployeeType.employeeId,
  employee_department: selectedemployeeType.department,
  employee_doj: selectedemployeeType.joiningDate,
  employee_title: selectedemployeeType.jobTitle,
  leave: selectedemployeeType.leave,
  sales_bill_amount: selectedemployeeType.salesbillamount,
  sales_bill_count: selectedemployeeType.salesbillcount,
  incentive: selectedemployeeType.incentive,
  working_days: selectedemployeeType.workingdays,
  performance: selectedemployeeType.performance,
  subject: `Promotion Request for ${selectedemployeeType.name}`,
  description: `Promotion request for ${selectedemployeeType.name} with employee ID ${selectedemployeeType.employeeId}.`,
  email: sessionStorage.getItem("email"),
  departmentid:"101716000000010772",
  lastname: sessionStorage.getItem("last_name"),
  firstname: sessionStorage.getItem("first_name"),
}

  
    try {
      const response = await fetch('/server/ticket_functions/createticket', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
        
      });

      console.log("payload", payload)
  setLoading(false);
      if (response) {
        // alert('Promotion form submitted successfully!');
         toast.success("Ticket submitted successfully!");
      } else {
        // alert('Failed to submit the form.');
        toast.error("Something went wrong while Ticket submitting!");
      }
    } catch (error) {
      console.error(error);
      alert('Error submitting the form');
    }
  };
 
      // const [filteredRows, setFilteredRows] = React.useState(allRows);
    const itemsPerPage = 5;
  
  
    const Navigate = useNavigate();

    const filteredData = employeeData.filter((ticket) =>
      ticket.name.toLowerCase().includes(search.toLowerCase())
    );

    const sortedData = [...filteredData].sort((a, b) => {
      if (!sortField) return 0;
      const aVal = a[sortField]?.toString().toLowerCase();
      const bVal = b[sortField]?.toString().toLowerCase();
  
      if (aVal < bVal) return sortOrder === "asc" ? -1 : 1;
      if (aVal > bVal) return sortOrder === "asc" ? 1 : -1;
      return 0;
    });
  
    // Pagination
    const totalPages = Math.ceil(sortedData.length / itemsPerPage);
    const paginatedData = sortedData.slice(
      (page - 1) * itemsPerPage,
      page * itemsPerPage
    );
  
    const handleSort = (field) => {
      console.log("field",field)
      if (sortField === field) {
        setSortOrder((prev) => (prev === "asc" ? "desc" : "asc"));
      } else {
        setSortField(field);
        setSortOrder("asc");
      }
    };
  
  


  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name in formData.performance) {
      setFormData((prev) => ({
        ...prev,
        performance: {
          ...prev.performance,
          [name]: value,
        },
      }));


      console.log("form datA ON CHANGE",formData);
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  return (
    <div>

         <Toaster position="top-center" richColors />
      {loading && (
  <div className="fixed inset-0 flex items-center justify-center bg-white/60 z-[9999]">
    <div className="animate-spin rounded-full h-12 w-12 border-4 border-red-500 border-t-transparent"></div>
  </div>
)}

      <div className="max-w-4xl mx-auto p-6 bg-white shadow-lg rounded-xl space-y-8 min-w-full">
        <div className="text-[30px] font-semibold mb-4 pb-2 text-center text-[#f0965b]">Promotion Form</div>
<form onSubmit={handleSubmit} className="space-y-6">


        <div>
          <h2 className="text-xl font-semibold mb-4 border-b-2 border-b-[#f0965b] pb-2">Employee Information</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium mb-1">Full Name</label>
              <Listbox value={selectedemployeeType} onChange={(val) => setSelectedemployeeType(val)}>
                <div className="relative">
                  <Listbox.Button className="w-full border border-gray-300 rounded px-4 py-2 text-left text-sm focus:outline-none focus:ring-2 focus:ring-[#EF7320] flex justify-between items-center">
                    {selectedemployeeType.name}
                    <ChevronDown className="w-4 h-4" />
                  </Listbox.Button>
                  <Listbox.Options className="absolute w-full mt-1 bg-white border border-gray-300 rounded shadow-md z-10">
                    {employeeData.map((option, idx) => (
                      <Listbox.Option
                        key={idx}
                        value={option}
                        className={({ active, selected }) =>
                          `cursor-pointer px-4 py-2 text-sm ${
                            active ? 'bg-orange-100 text-orange-700' : 'text-gray-800'
                          } ${selected ? 'font-semibold' : ''}`
                        }
                      >
                        {({ selected }) => (
                          <div className="flex justify-between items-center">
                            {option.name}
                            {selected && <Check className="w-4 h-4 text-[#EF7320]" />}
                          </div>
                        )}
                      </Listbox.Option>
                    ))}
                  </Listbox.Options>
                </div>
              </Listbox>
            </div>

            <div>
              <label className="block text-sm font-medium mb-1">Employee ID</label>
              <input type="text" value={selectedemployeeType.employeeId || ''} readOnly className="w-full border border-gray-300 rounded-none px-3 py-2 outlineclr bg-gray-100 "  onChange={handleChange} />
            </div>

            <div>
              <label className="block text-sm font-medium mb-1">Current Job Title</label>
              <input type="text" value={selectedemployeeType.jobTitle || ''} readOnly className="w-full border border-gray-300 rounded px-3 py-2 outlineclr bg-gray-100 " />
            </div>

            <div>
              <label className="block text-sm font-medium mb-1">Department</label>
              <input type="text" value={selectedemployeeType.department || ''} readOnly className="w-full border border-gray-300 rounded px-3 py-2 outlineclr bg-gray-100 " />
            </div>

            <div className="md:col-span-2">
              <label className="block text-sm font-medium mb-1">Date of Joining</label>
              <input type="date" value={selectedemployeeType.joiningDate || ''} readOnly className="w-full border border-gray-300 rounded px-3 py-2 outlineclr bg-gray-100 " />
            </div>
          </div>
        </div>


        {/* Table  */}
        <div>
         
          <div className="overflow-x-auto">
           {/* Table  */}
<div>
  <h2 className="text-xl font-semibold mb-4 border-b-2 border-b-[#f0965b] pb-2">Employees Details</h2>
  <div className="p-4 space-y-6 mt-10">
 

{/* <div className="overflow-x-auto">
    <table className="w-full table-auto border-collapse">
      <thead className="bg-[#EF7320] text-white">
        <tr>
          <th className="px-4 py-2 text-left">Employee Name</th>
          <th className="px-4 py-2 text-left">Employee Id</th>
          <th className="px-4 py-2 text-left">Job Title</th>
          <th className="px-4 py-2 text-left">Department</th>
          <th className="px-4 py-2 text-left">Experience</th>
          <th className="px-4 py-2 text-left">salary</th>
        </tr>
      </thead>
      <tbody>
        {selectedemployeeType.employeeId !== undefined ? (
          <tr className="border-b text-sm text-gray-700 bg-gray-50 hover:bg-gray-100">
            <td className="px-4 py-2">{selectedemployeeType.name}</td>
            <td className="px-4 py-2">{selectedemployeeType.employeeId}</td>
            <td className="px-4 py-2">{selectedemployeeType.jobTitle}</td>
            <td className="px-4 py-2">{selectedemployeeType.department}</td>
            <td className="px-4 py-2">{selectedemployeeType.experience}</td>
            <td className="px-4 py-2">{selectedemployeeType.salary}</td>
          </tr>
        ) : (
          <tr>
            <td className="px-4 py-2 text-center text-gray-500" colSpan="6">
              No Employee data available 
            </td>
          </tr>
        )}
      </tbody>
    </table>
  </div> */}
 {/* Table */}
 <div className="overflow-x-auto rounded-md shadow border border-gray-300">
   <table className="min-w-full text-sm text-left  border-collapse border-2 border-gray-300">
     <thead className="bg-[#EF7320] text-white text-sm">
       <tr>
         {[
           { label: "Employee Name", key: "name" },
           { label: "Employee ID", key: "employeeId" },
          { label: "Job Title", key: "jobTitle" },
            { label: "Department", key: "department" },
          //   { label: "Joining Date", key: "joiningDate" },
          //   { label: "Working Days", key: "workingdays" },
          //   { label: "Leave", key: "leave" },
          //   { label: "Incentive", key: "incentive" },
          //   { label: "Performance", key: "performance" },
          //   { label: "Sales Bill Count", key: "salesbillcount" },
          //   { label: "Sales Bill Amount", key: "salesbillamount" },
           { label: "Experience", key: "experience" },
           { label: "salary", key: "salary" },
          
         ].map(({ label, key }) => (
           <th
             key={key}
             onClick={() => handleSort(key)}
             className="px-4 py-2 cursor-pointer select-none"
           >
             {label}
             {sortField === key ? (sortOrder === "asc" ? " ▲" : " ▼") : ""}
           </th>
         ))}
       </tr>
     </thead>
     <tbody>
     {selectedemployeeType.employeeId !== undefined ? (
          <tr className=" text-sm text-gray-700 bg-[#f4e4d9] hover:bg-gray-100">
            <td className="px-4 py-2">{selectedemployeeType.name}</td>
            <td className="px-4 py-2">{selectedemployeeType.employeeId}</td>
            <td className="px-4 py-2">{selectedemployeeType.jobTitle}</td>
            <td className="px-4 py-2">{selectedemployeeType.department}</td>
            <td className="px-4 py-2">{selectedemployeeType.experience}</td>
            <td className="px-4 py-2">{selectedemployeeType.salary}</td>
          </tr>
        ) : (
          <tr>
            <td className="px-4 py-2 text-center text-gray-500" colSpan="6">
              No Employee data available 
            </td>
          </tr>
        )}
       {paginatedData.length > 0 ? (
         paginatedData.map((ticket) => (
           <tr
             key={ticket.id}
            //  className="odd:bg-gray-100 even:bg-gray-200 text-gray-800".
            className=" bg-gray-100 text-gray-800"
           >
             <td className="px-4 py-2">{ticket.name}</td>
             <td className="px-4 py-2">{ticket.employeeId}</td>
             <td className="px-4 py-2">{ticket.jobTitle}</td>
             <td className="px-4 py-2">{ticket.department}</td>
             <td className="px-4 py-2">{ticket.experience}</td>
             <td className="px-4 py-2">{ticket.salary}</td>
        
           
           </tr>
         ))
       ) : (
         <tr>
           <td colSpan="7" className="text-center py-4 text-gray-500">
             No tickets found.
           </td>
         </tr>
       )}
     </tbody>
   </table>
 </div>

 {/* Pagination */}
 <div className="flex justify-between items-center mt-4">
   <span className="text-sm text-gray-600">
     Page {page} of {totalPages}
   </span>
   <div className="flex items-center gap-2">
     <button
       onClick={() => setPage((prev) => Math.max(prev - 1, 1))}
       disabled={page === 1}
       className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50"
     >
       <ChevronLeft size={18} />
     </button>
     <button
       onClick={() => setPage((prev) => Math.min(prev + 1, totalPages))}
       disabled={page === totalPages}
       className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50"
     >
       <ChevronRight size={18} />
     </button>
   </div>
 </div>
</div>
  
</div>

          </div>
        </div>

        {/* Promotion Details */}
        <div>
          <h2 className="text-xl font-semibold mb-4 border-b-2 border-b-[#f0965b] pb-2">Proposed Promotion Details</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium mb-1">New Job Title</label>
              <input type="text" className="w-full border border-gray-300 rounded px-3 py-2 outlineclr" />
            </div>
            <div>
              <label className="block text-sm font-medium mb-1">Effective Date</label>
              <input type="date" className="w-full border border-gray-300 rounded px-3 py-2 outlineclr" />
            </div>
            <div>
              <label className="block text-sm font-medium mb-1">New Department (if applicable)</label>
              <input type="text" className="w-full border border-gray-300 rounded px-3 py-2 outlineclr" />
            </div>
            <div>
              <label className="block text-sm font-medium mb-1">New Reporting Manager</label>
              <input type="text" className="w-full border border-gray-300 rounded px-3 py-2 outlineclr" />
            </div>
          </div>
        </div>

        {/* Performance Summary */}
        <div>
          <h2 className="text-xl font-semibold mb-4 border-b-2 border-b-[#f0965b] pb-2">Performance Summary</h2>
          <div className="space-y-4">
            {performanceFields.map((field) => (
              <div className="space-y-2" key={field.name}>
                <label className="block font-medium">{field.label}</label>
                <div className="flex items-center space-x-4">
                  {[1, 2, 3, 4, 5].map((num) => (
                    <label className="custom-container" key={num}>
                      {num}
                      <input
                        type="radio"
                        name={field.name}
                        value={num}
                        checked={ratings[field.name] === num}
                        onChange={() => handleChange(field.name, num)}
                      />
                      <span className="custom-radio-mark"></span>
                    </label>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Justification */}
        <div>
          <h2 className="text-xl font-semibold mb-4 border-b-2 border-b-[#f0965b] pb-2">Justification for Promotion</h2>
          <div className="space-y-4">
            <div>
              <label className="block text-sm font-medium mb-1">Provide reasons for recommending this promotion</label>
              <textarea className="w-full border border-gray-300 rounded px-3 py-2 outlineclr" rows="3"></textarea>
            </div>
            <div>
              <label className="block text-sm font-medium mb-1">Key Achievements</label>
              <textarea className="w-full border border-gray-300 rounded px-3 py-2 outlineclr" rows="3"></textarea>
            </div>
          </div>
        </div>

        {/* Signatures */}
        <div>
          <h2 className="text-xl font-semibold mb-4 border-b-2 border-b-[#f0965b] pb-2">Signatures</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium mb-1">Proposed By</label>
              <input type="text" className="w-full border border-gray-300 rounded px-3 py-2 outlineclr" />
              <label className="block text-sm font-medium mt-2 mb-1">Date</label>
              <input type="date" className="w-full border border-gray-300 rounded px-3 py-2 outlineclr" />
            </div>
            <div>
              <label className="block text-sm font-medium mb-1">Approved By</label>
              <input type="text" className="w-full border border-gray-300 rounded px-3 py-2 outlineclr" />
              <label className="block text-sm font-medium mt-2 mb-1">Date</label>
              <input type="date" className="w-full border border-gray-300 rounded px-3 py-2 outlineclr" />
            </div>
          </div>
        </div>

<div className="flex justify-center mt-6">


          <button type="submit" className=" bg-[#EF7320] text-white font-medium py-2 px-4 rounded hover:bg-orange-600">Submit</button>
        
</div>
        </form>
      </div>
    </div>
  );
};
